import BaseClass from "./BaseClass";
import Helper from "./Helper";

const defaultOptions = {};

export default class Header extends BaseClass {

    constructor(options)
    {
        super(options, defaultOptions);

        this.init();
    }

    init()
    {
        $(document).ready(function () {
            let header = $("#header");
            let dim = $("#dim");
            let body = $("body");
            let html = $("html");
            let footer = $("#footer-client");

            if ($(header).length > 0) {
                $(".nav-list-item").on('click', function (e) {
                    let clickedNav = $(this);
                    // firstly close other opened subnavs
                    $(".nav-list-item").each(function (i, elem) {
                        if ($(elem).data('show') !== $(clickedNav).data('show')) {
                            $(elem).removeClass('active');
                            let hideBlock = $(elem).data('show');
                            let hideDiv = $("[data-name='"+hideBlock+"']")
                            hideDiv.removeClass('active');
                            $(header).removeClass('subnav-active');
                        }
                    });

                    let showBlockString = $(this).data('show');
                    let showDiv = $("[data-name='"+showBlockString+"']");

                    if ($(showDiv).hasClass('active')) {
                        showDiv.removeClass('active');
                        $(this).removeClass('active');
                        $(body).removeClass("no-scroll");
                        $(header).removeClass('subnav-active');

                        if (showBlockString === "menuSubNav") {
                            $(dim).css('display', 'none');
                        }

                        if (Helper.isBigMobileOrLower()) {
                            $(html).css({'overflow-y': 'unset'})
                        }
                    } else {
                        $(this).addClass('active');
                        showDiv.addClass('active');
                        $(header).addClass('subnav-active');

                        if (Helper.isBigMobileOrLower()) {
                            $(body).addClass("no-scroll");
                            $(html).css({'overflow-y': 'hidden'})
                        }

                        if (showBlockString === "menuSubNav") {
                            let contentHeight = Helper.setBodyHeight(true);
                            contentHeight += $(footer).actual('outerHeight');

                            $(body).addClass("no-scroll");

                            if (!Helper.isBigMobileOrLower()) {
                                $(dim).css({
                                    'display': 'block',
                                    'width' : window.innerWidth - $(showDiv)[0].offsetWidth + "px",
                                });
                            }

                            $(showDiv).css('height', window.innerHeight + "px");

                            if (!Helper.isBigMobileOrLower()) {
                                $(dim).css({
                                    'height': contentHeight + "px",
                                });
                            }
                        }
                    }
                });

                // mobile
                $(".nav-list-item").on('touchstart', function (e) {
                    if (Helper.isBigMobileOrLower()) {
                        let clickedNav = $(this);
                        // firstly close other opened subnavs
                        $(".nav-list-item").each(function (i, elem) {
                            if ($(elem).data('show') !== $(clickedNav).data('show')) {
                                $(elem).removeClass('mvio-hover');
                            }
                        });

                        if ($(this).hasClass('mvio-hover')) {
                            $(this).removeClass('mvio-hover');
                        } else {
                            $(this).addClass('mvio-hover');
                        }
                    }
                });

                // handle window resizing and dim effect
                $(window).resize(function () {
                    let contentHeight = Helper.setBodyHeight();
                    contentHeight += $(footer).actual('outerHeight');

                    if (!Helper.isBigMobileOrLower() && $("[data-name='menuSubNav']").hasClass('active')) {
                        $(dim).css('display', 'block');
                    } else {
                        $(dim).css('display', 'none');
                    }

                    $("[data-name='menuSubNav']").css('height', window.innerHeight + "px");
                    if (!Helper.isBigMobileOrLower()) {
                        $(dim).css({
                            'width': window.innerWidth - $("[data-name='menuSubNav']")[0].offsetWidth + "px",
                            'height': contentHeight + "px",
                        });
                    }
                });

                $(".nav-list-item").each(function () {
                    /**
                     * Registering as document click observer
                     */
                    window.documentClickObserve.register(($clickedElement) => {
                        let name = $(this).data('show');

                        if (!$clickedElement.closest('[data-show]').length && !$clickedElement.closest('[data-name]').length) {
                            if (name === 'menuSubNav') {
                                $(body).removeClass("no-scroll");
                                $(dim).css('display', 'none');
                            }

                            $(this).removeClass('active');
                            $('[data-name="' + name + '"]').removeClass('active');
                            $(header).removeClass('subnav-active');
                        }
                      });
                });

                let nav = $(header).find("[data-header-sticky]").first();

                if ($(nav).hasClass('with-shadow__tablet')) {
                    $(window).scroll((event) => {
                        let scroll = $(window).scrollTop();
                        let headerHeight = $(header).actual('outerHeight') - $(nav).actual('outerHeight');

                        if (scroll >= headerHeight) {
                            $(nav).addClass('with-shadow__tablet--show');
                        } else {
                            $(nav).removeClass('with-shadow__tablet--show');
                        }
                    });
                }

                if ($(nav).hasClass('with-shadow__mobile')) {
                    $(window).scroll((event) => {
                        let scroll = $(window).scrollTop();
                        let headerHeight = $(header).actual('outerHeight') - $(nav).actual('outerHeight');

                        if (scroll >= headerHeight) {
                            $(nav).addClass('with-shadow__mobile--show');
                        } else {
                            $(nav).removeClass('with-shadow__mobile--show');
                        }
                    });
                }
            }
        });
    }

  /**
   * Function that changes language of site
   * @param {String} code language code
   */
    languageSelectBoxes(code)
    {
        let url = window.location.pathname;
        url = url.split('/');
        let newUrl = code;
        for (let i = 0; i <= (url.length - 1); i++) {
            if (i > 1) {
                newUrl += '/' + url[i];
            }
        }

        window.location.href = window.location.origin + '/' + newUrl;
    }
}
